<style scoped>
    .amount-of-money{color: #f64b4b;font-size: 24px}
    .amount-of-money-source{color: #464c5b;font-size: 14px}
    .receivables{font-size: 14px;color: #464c5b;font-weight: bold;}
</style>

<template>
  <div>
<!--    对账-->
    <Modal
        v-model="reconciliation.panel"
        title="录入对账数据"
        @on-ok="saveState(1)"
        ok-text="保存"
    >
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">案号：</Col>
        <Col span="16"><Input v-model="reconciliation.caseNumber" placeholder="输入案号"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">委托人：</Col>
        <Col span="16"><Input v-model="reconciliation.clientName" placeholder="输入委托人"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">付款人：</Col>
        <Col span="16"><Input v-model="reconciliation.payName" placeholder="输入付款人"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">付款金额：</Col>
        <Col span="16"><Input v-model="reconciliation.amount" placeholder="输入付款金额"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">付款时间：</Col>
        <Col span="16">
          <DatePicker type="date" @on-change="reconciliation.payDate = $event" placeholder="请选择日期" style="width: 200px"></DatePicker>
        </Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">付款方式：</Col>
        <Col span="16">
          <Select style="width:200px" v-model="reconciliation.payType" filterable placeholder="选择收费方式">
            <Option value="现金">现金</Option>
            <Option value="转账">转账</Option>
            <Option value="刷卡">刷卡</Option>
            <Option value="其他">其他</Option>
          </Select>
        </Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">付款凭证：</Col>
        <Col span="16">
          <Upload
              :show-upload-list="false"
              :on-success="uploadSuccess"
              style="display: inline-block;vertical-align:middle"
              :headers="{GroupId:groupId,Con:'R',Fun:'upload_file',UserLogin:phoneNumber,UserToken:userToken,Ver:'v1'}"
              :data="{MenuId:menuId,UserId:userId}"
              :action="getServerURL('default',true)">
            <Button
                icon="ios-cloud-upload-outline"
                :type="reconciliation.file.name?'success':'primary'"
            >
              {{reconciliation.file.name||'请选择文件'}}
            </Button>
          </Upload>
        </Col>
      </Row>
    </Modal>
<!--    开票-->
    <Modal
        v-model="invoice.panel"
        title="录入开票数据"
        @on-ok="saveState(2)"
        ok-text="保存"
    >
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">案号：</Col>
        <Col span="16"><Input v-model="invoice.caseNumber" placeholder="输入案号"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">委托人：</Col>
        <Col span="16"><Input v-model="invoice.clientName" placeholder="输入委托人"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">开票对象：</Col>
        <Col span="16"><Input v-model="invoice.invoiceName" placeholder="输入开票对象"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">税号：</Col>
        <Col span="16"><Input v-model="invoice.taxNum" placeholder="输入税号"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">附件上传：</Col>
        <Col span="16">
          <Upload
              :show-upload-list="false"
              :on-success="uploadSuccessInvoice"
              style="display: inline-block;vertical-align:middle"
              :headers="{GroupId:groupId,Con:'R',Fun:'upload_file',UserLogin:phoneNumber,UserToken:userToken,Ver:'v1'}"
              :data="{MenuId:menuId,UserId:userId}"
              :action="getServerURL('default',true)">
            <Button
                icon="ios-cloud-upload-outline"
                :type="invoice.file.name?'success':'primary'"
            >
              {{reconciliation.file.name||'请选择文件'}}
            </Button>
          </Upload>
        </Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">开票金额：</Col>
        <Col span="16"><Input v-model="invoice.invoiceAmount" placeholder="开票金额"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">是否到账：</Col>
        <Col span="16">
          <Input v-model="invoice.payState" placeholder="资金到账状态"></Input>
        </Col>
      </Row>
      <Row type="flex" align="middle" style="padding: 10px 0">
        <Col span="6" style="text-align: right">合同是否签返：</Col>
        <Col span="16"><Input v-model="invoice.contractState" placeholder="合同签返状态"></Input></Col>
      </Row>
    </Modal>
    <!--    提成-->
    <Modal
        v-model="royalty.panel"
        title="录入提成数据"
        @on-ok="saveState(3)"
        ok-text="保存"
    >
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">案号：</Col>
        <Col span="16"><Input v-model="royalty.caseNumber" placeholder="输入案号"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding:10px 0">
        <Col span="6" style="text-align: right">委托人：</Col>
        <Col span="16"><Input v-model="royalty.clientName" placeholder="输入委托人"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding: 10px 0">
        <Col span="6" style="text-align: right">到账金额：</Col>
        <Col span="16"><Input v-model="royalty.amount" placeholder="输入到账金额"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding: 10px 0">
        <Col span="6" style="text-align: right">合同是否签返：</Col>
        <Col span="16"><Input v-model="royalty.contractState" placeholder="合同签返状态"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding: 10px 0">
        <Col span="6" style="text-align: right">发票是否开具：</Col>
        <Col span="16"><Input v-model="royalty.invoiceState" placeholder="发票开具状态"></Input></Col>
      </Row>
      <Row type="flex" align="middle" style="padding: 10px 0">
        <Col span="6" style="text-align: right">提成比例：</Col>
        <Col span="6"><Input v-model="royalty.proportion" @on-change="parseInt(royalty.royaltyAmount = royalty.proportion*royalty.amount/100)" placeholder="提成比例"></Input></Col>
        <Col span="10"> %</Col>
      </Row>
      <Row type="flex" align="middle" style="padding: 10px 0">
        <Col span="6" style="text-align: right">提成总额：</Col>
        <Col span="16"><Input v-model="royalty.royaltyAmount" placeholder="自动计算总额"></Input></Col>
      </Row>
      <Row type="flex" align="top" style="padding: 10px 0" v-if="projectUser.length>0&&royalty.royaltyAmount">
        <Col span="6" style="text-align: right;line-height:32px;">提成分配：<br/>（可直接填写金额）</Col>
        <Col span="16">
          <Row v-for="(item,index) in royalty.list" type="flex" align="middle" :key="'projectRoyalty'+item.id+index">
            <Col span="5" style="text-align: right;">
              {{userList.find((secItem)=>{return secItem.id==item.id}).name}}：
            </Col>
            <Col span="19">
              <Input v-model="item.proportion" @on-change="item.amount=parseInt(royalty.royaltyAmount*item.proportion/100)" style="width:50px;text-align: center" placeholder="比例"></Input>%
              =
              <Input v-model="item.amount" style="width:100px" placeholder="金额"></Input>￥
              <Icon style="color:red;cursor: pointer;" @click="royalty.list.splice(index,1)" type="md-close-circle"></Icon>
            </Col>
            <div style="padding: 5px;"></div>
          </Row>
          <userSelector
              style="float: right"
              :userList="userList"
              @inputChange="getUserList($event)"
              @selected="addRoyalty($event.id)"
          >
            <template slot="title">
              <p style="color:#aaa">+添加成员</p>
            </template>
          </userSelector>
        </Col>
      </Row>
    </Modal>
    <!--收账余额-->
    <Row style="text-align: center;height: 105px;display: flex;align-items: center;border-bottom: 1px solid #d7dde4">
      <Col span="1">&nbsp;</Col>
      <Col span="4">
        <p class="amount-of-money">{{amount.sum}}</p>
        <p class="amount-of-money-source">合同金额</p>
      </Col>
      <Col span="4">
        <p class="amount-of-money">{{amount.received}}</p>
        <p class="amount-of-money-source">已收金额</p>
      </Col>
      <Col span="4">
        <p class="amount-of-money">{{amount.notReceived}}</p>
        <p class="amount-of-money-source">待收金额</p>
      </Col>
      <Col span="4">
        <p class="amount-of-money">{{amount.royalty}}</p>
        <p class="amount-of-money-source">项目提成</p>
      </Col>
      <Col span="1">&nbsp;</Col>
      <Col span="6" v-if="$route.query.filed!=1">
        <Button @click="reconciliationState()" type="warning" shape="circle" style="width:80px;height: 36px;font-size: 14px;color: #f9f9f9">对账</Button>
        <span style="padding: 5px"></span>
        <Button @click="invoiceState()" type="primary" shape="circle" style="width:80px;height: 36px;font-size: 14px;color: #f9f9f9">开票</Button>
        <span style="padding: 5px"></span>
        <Button @click="editState()" type="success" shape="circle" style="width:80px;height: 36px;font-size: 14px;color: #f9f9f9">提成</Button>
      </Col>
    </Row>
    <Menu mode="horizontal" :active-name=type.toString() @on-select="type=$event">
      <MenuItem name="1">
        对账列表
      </MenuItem>
      <MenuItem name="2">
        开票列表
      </MenuItem>
      <MenuItem name="3">
        提成列表
      </MenuItem>
    </Menu>
    <!--收款流程-->
    <Row style="text-align: center;height: 62px;border-bottom: 1px solid #d7dde4;line-height: 62px">
      <Col span="4" class="receivables">收款金额</Col>
      <Col span="4" class="receivables">发起时间</Col>
      <Col span="4" class="receivables">确认时间</Col>
      <Col span="4" class="receivables">确认金额</Col>
      <Col span="4" class="receivables">流水状态</Col>
      <Col span="4" class="receivables">操作</Col>
    </Row>
    <!--是否收款-->
    <Row style="text-align: center;height: 94px;border-bottom: 1px solid #d7dde4;line-height: 94px" v-for="(item,index) in list">
      <Col span="4">￥{{item.amount||'--'}}</Col>
      <Col span="4">{{item.createTime||'--'}}</Col>
      <Col span="4">{{item.affirmatoryTime||'--'}}</Col>
      <Col span="4">{{item.affirmatoryAmount ||'--'}}</Col>
      <Col span="4">{{trackingStateList.find((secItem)=>{return secItem.value==item.state}).name||'--'}}</Col>
      <Col span="4">
        <Button v-if="item.state==true" :disabled="true" type="primary" @click="confirmedTracking(item.id)">已确认</Button>
        <Button v-else type="error" @click="deleteReceivables(item.id)">撤回</Button>
      </Col>
    </Row>
    <!--分页-->
    <Row>
      <Col span="24" style="margin:40px 0 57px 0;">
        <Page
            :show-sizer="true"
            :show-total="true"
            @on-page-size-change="search.pageSize=$event;getReceivablesList()"
            :total="search.total"
            :page-size="search.pageSize"
            :page-size-opts="[5,10,15]"
            show-elevator
            @on-change="search.page = $event;getReceivablesList()"
        />
      </Col>
    </Row>
  </div>
</template>

<script>
  import userSelector from '../../../components/system/userSelector'
  export default {
    name: "receivables",//收款
    data:function () {
      return{
        type:1,
        invoice:{
          panel:false,
          invoiceName:'',
          caseNumber:'',
          clientName:'',
          taxNum:'',
          invoiceAmount:'',
          payState:'',
          contractState:'',
          file:{
            name:'',
            src:'',
          },
        },
        list:[],
        amount:{
          caseNumber:'',
          clientName:'',
          contractState:'',
          invoiceState:'',
          sum:0,
          received:0,
          notReceived:0,
          royalty:0,
        },
        reconciliation:{
          panel:false,
          payType:'',
          caseNumber:'',
          clientName:'',
          payName:'',
          amount:'',
          payDate:'',
          file:{
            name:'',
            src:'',
          },
        },
        content:{},
        payTypeList:[],
        trackingList:[],
        trackingStateList:[],
        royalty:{
          panel:false,
          caseNumber:'',
          clientName:'',
          amount:'',
          contractState:'',
          invoiceState:'',
          proportion:'',
          royaltyAmount:'',
          amountState:2,
          list:[

          ],
        },
        projectUser:[],
        client:[],
        opposed:[],
        userList:[],
        search:{
          pageSize: 5,//每页显示多少条
          total: 0,//总条数
          page: 1,//当前页
        },
      }
    },
    components:{
      userSelector:userSelector,
    },
    mounted:function () {
      // this.getReceivablesAmount()
      this.getTrackingStateList()
      this.getLawList()
      this.getUserList()
      this.getPayType()
      this.projectRegister()
      this.getLitigationList()
    },
    watch:{
      'type':function () {
        this.getReceivablesList()
      }
    },
    methods:{
      //增加提成用户
      addRoyalty:function(id){
        this.royalty.list.push({
          id:id,
          proportion:0,
          amount:0,
        })
      },
      //获取用户数据
      getUserList:function(searchText){
        var _this = this
        _this.userList = []
        _this.send({
          headers:'C/LawList',
          data:{
            key:searchText||'',
          },
          success:function (res) {
            var tempObj = []
            for(var index in res){
              tempObj.push({id:res[index].UserId,name:res[index].UserName,icon:res[index].UserImg})
            }
            _this.userList = tempObj
          }
        })
      },

      invoiceState:function(){
        var tempClientName = []
        var tempClientAddress = []
        var tempOpposedName = []
        for(var i=0;i<this.client.length;i++){
          tempClientName.push(this.client[i].name,)
          tempClientAddress.push(this.client[i].address,)
        }
        for(var i=0;i<this.opposed.length;i++){
          tempOpposedName.push(this.opposed[i].name)
        }
        var tempManageName = []
        for(var i=0;i<this.content.manager;i++){
          if(this.userList.find((secItem)=>{return secItem.id==this.content.manager[i]})){
            tempManageName.push(this.userList.find((secItem)=>{return secItem.id==this.content.manager[i]}).name)
          }
        }
        this.invoice.caseNumber = this.content.caseNumber
        this.invoice.clientName = tempClientName.toString()
        this.invoice.panel = true
      },

      editState:function(){
        var tempClientName = []
        var tempClientAddress = []
        var tempOpposedName = []
        for(var i=0;i<this.client.length;i++){
          tempClientName.push(this.client[i].name,)
          tempClientAddress.push(this.client[i].address,)
        }
        for(var i=0;i<this.opposed.length;i++){
          tempOpposedName.push(this.opposed[i].name)
        }
        var tempManageName = []
        for(var i=0;i<this.content.manager;i++){
          if(this.userList.find((secItem)=>{return secItem.id==this.content.manager[i]})){
            tempManageName.push(this.userList.find((secItem)=>{return secItem.id==this.content.manager[i]}).name)
          }
        }
        this.royalty.caseNumber = this.content.caseNumber
        this.royalty.clientName = tempClientName.toString()
        this.royalty.panel = true
      },
      //对账状态
      reconciliationState:function(){
        //   {"name":"approvalInput","content":{"title":"申请人","text":tempClientName.toString()}},
        //   {"name":"approvalInput","content":{"title":"住所","text":tempClientAddress[0]}},
        //   {"name":"approvalInput","content":{"title":"联系人","text":_this.content.contactName}},
        //   {"name":"approvalInput","content":{"title":"联系方式","text":_this.content.contactMobile}},
        //   {"name":"approvalInput","content":{"title":"对方当事人","text":tempOpposedName.toString()}},
        //   // {"name":"approvalInput","content":{"title":"第三人","text":null}},
        //   {"name":"approvalInput","content":{"title":"案由","text":_this.content.cause}},
        //   {"name":"approvalInput","content":{"title":"委托人","text":tempClientName.toString()}},
        //   {"name":"approvalInput","content":{"title":"主办律师","text":tempManageName.toString()}},
        //   {"name":"approvalInput","content":{"title":"受理机关","text":_this.content.receivingUnitText}},
        //   {"name":"approvalInput","content":{"title":"审级或阶段","text":_this.content.caseStage}},
        //   {"name":"approvalInput","content":{"title":"争议标的额","text":_this.content.casetAmount}},
        //   {"name":"approvalInput","content":{"title":"收费比例/金额","text":_this.content.projectAmount}},
        //   {"name":"approvalInput","content":{"title":"收费方式","text":_this.payTypeList.find((secItem)=>{return secItem.id==_this.content.payType}).name}},
        //   {"name":"approvalInput","content":{"title":"结算方式","text":_this.content.settlementMethod}},
        //   {"name":"approvalTextarea","content":{"title":"简要案情","text":_this.content.caseDetails}}
        var tempClientName = []
        var tempClientAddress = []
        var tempOpposedName = []
        for(var i=0;i<this.client.length;i++){
          tempClientName.push(this.client[i].name,)
          tempClientAddress.push(this.client[i].address,)
        }
        for(var i=0;i<this.opposed.length;i++){
          tempOpposedName.push(this.opposed[i].name)
        }
        var tempManageName = []
        for(var i=0;i<this.content.manager;i++){
          if(this.userList.find((secItem)=>{return secItem.id==this.content.manager[i]})){
            tempManageName.push(this.userList.find((secItem)=>{return secItem.id==this.content.manager[i]}).name)
          }
        }
        this.reconciliation.caseNumber = this.content.caseNumber
        this.reconciliation.clientName = tempClientName.toString()
        this.reconciliation.panel = true
      },
      //获取收费方式
      getPayType:function(){
        var _this = this
        _this.payTypeList = []
        _this.send({
          headers:'C/CaseChargeList',
          success:function (res) {
            for(var index in res){
              _this.payTypeList.push({
                id:res[index].CaseChargeId,
                name:res[index].CaseChargeTitle,
              })
            }
          }
        })
      },

      uploadSuccess:function (response,file,fileList) {
        this.reconciliation.file.name = response.Data.name
        this.reconciliation.file.src = response.Data.path
        this.$Notice.success({
          title:'系统提示',
          desc:'文件上传成功！'
        })
      },

      uploadSuccessInvoice:function (response,file,fileList) {
        this.invoice.file.name = response.Data.name
        this.invoice.file.src = response.Data.path
        this.$Notice.success({
          title:'系统提示',
          desc:'文件上传成功！'
        })
      },
      //获取案件数据
      projectRegister: function () {
        var _this = this
        _this.send({
          headers: "E/ShowSingleCase",
          data: {
            CaseId: _this.$route.query.caseId
          },
          success: function (res) {
            _this.content.name=res.case_title
            _this.content.caseNumber=res.case_num
            _this.content.caseAmount=res.case_subject_matter
            _this.content.projectAmount=res.case_pay_count
            _this.content.caseStage=res.case_stage
            _this.content.caseDetails=res.case_situation
            _this.content.createDate=res.case_create_time
            _this.content.caseTypeId=res.case_type_id
            _this.content.payType=parseInt(res.case_charge_id)
            _this.content.receivingUnit=parseInt(res.case_acceptance_id)
            _this.content.causeTypeSelected=res.case_action_id//案由ID
            _this.content.cause=res.case_action_info//案由
            _this.content.modelTypeSelected=res.case_action_second_id//细分模板ID
            _this.content.modelSelected=res.case_action_detail_id//模板ID
            _this.content.source=res.case_from_id?res.case_from_id.split(','):[]
            _this.content.manager=res.case_executor_id?res.case_executor_id.split(','):[]
            _this.content.otherUser=res.case_member_id?res.case_member_id.split(','):[]
          }
        })
      },
      //发起对账
      createReconciliation:function(){
        var _this = this
        _this.send({
          headers:'G/CheckBill',
          data:{
            ProceedsTypeId:_this.type,
            ProceedsContent:'',
            CaseId:_this.$route.query.caseId,//案件id
            CaseNum:_this.reconciliation.caseNumber,//案号
            ProceedsUser:_this.reconciliation.payName,//付款人
            ProceedsCount:_this.reconciliation.amount,//金额
            ProceedsVoucher:_this.reconciliation.file.src,//收款凭证
            ProceedsPayway:_this.reconciliation.payType,//付款方式
            ProceedsPayTime:_this.reconciliation.payDate,//付款时间
          },
          success:function () {
            _this.getTrackingStateList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'添加对账数据成功！',
            })
          }
        })
      },
      //开票
      createInvoice:function(){
        var _this = this
        _this.send({
          headers:'G/AddMakeinvoice',
          data:{
            ProceedsTypeId:_this.type,
            ProceedsContent:'',
            CaseId:_this.$route.query.caseId,//案件id
            CaseNum:_this.invoice.caseNumber,//案号
            ProceedsBillMandator:_this.invoice.clientName,//委托人
            ProceedsBillUser:_this.invoice.invoiceName,//开票对象
            ProceedsBillNum:_this.invoice.taxNum,//税号
            ProceedsBillVoucher:_this.invoice.file.src,//附件
            ProceedsBillCount:_this.invoice.invoiceAmount,//开票金额
            ProceedsIspay:_this.invoice.payState,//是否到账
            ProceedsIsbacksign:_this.invoice.contractState,//合同是否签返
          },
          success:function () {
            _this.getTrackingStateList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'添加开票数据成功！',
            })
          }
        })
      },
      //发起提成
      createRoyalty:function(){
        var _this = this
        var tempArr = []
        for(var i=0;i<_this.edit.royalty.length;i++){
          tempArr.push({
            UserId:_this.edit.royalty[i].id,
            UserCount:_this.edit.royalty[i].amount,
          })
        }
        _this.send({
          headers:'G/AddRatio',
          data:{
            ProceedsTypeId:_this.type,
            ProceedsContent:'',
            CaseId:_this.$route.query.caseId,
            CaseNum:_this.royalty.caseNumber,//案号
            ProceedsBillmoneyMandator:_this.royalty.clientName,//委托人
            ProceedsBillmoneyCount:_this.royalty.amount,//到账金额
            ProceedsIsbacksign:_this.royalty.contractState,//合同是否签返
            ProceedsIsbill:_this.royalty.invoiceState,//发票是否开具
            ProceedsBillmoneyRatio:_this.royalty.proportion,//提成比例
            ProceedsRatioCount:_this.royalty.royaltyAmount,//提成总额
            UserRatio:tempArr,//提成分配
          },
          success:function () {
            _this.getTrackingStateList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'添加提成数据成功！',
            })
          }
        })
      },
      //保存数据
      saveState:function(type){
        var _this = this
        var data = {}
        var tempArr = []
        if(type==1){
          data = {
            ProceedsTypeId:type,
            ProceedsContent:{
              reconciliation:_this.reconciliation,
            },
            ProceedsCount:_this.reconciliation.amount,
            CaseId:_this.$route.query.caseId,
          }
        }
        if(type==2){
          data = {
            ProceedsTypeId:type,
            ProceedsContent:{
              invoice:_this.invoice,
            },
            ProceedsCount:_this.invoice.invoiceAmount,
            CaseId:_this.$route.query.caseId,
          }
        }
        if(type==3){
          for(var i=0;i<_this.royalty.list.length;i++){
            tempArr.push({
              UserId:_this.royalty.list[i].id,
              WageCount:_this.royalty.list[i].amount,
            })
          }
          data = {
            ProceedsTypeId:type,
            ProceedsContent:{
              UserWegeArr:tempArr,
              royalty:_this.royalty,
            },
            ProceedsCount:_this.royalty.amount,//金额
            CaseId:_this.$route.query.caseId,
            UserWegeArr:tempArr,
          }
        }
        _this.send({
          headers:'G/MakeBilling',
          data:data,
          success:function () {
            _this.getTrackingStateList()
            _this.$Notice.success({
              title:'系统消息',
              desc:'添加收账金额成功',
            })
          }
        })
      },
      //获取项目内用户列表
      getLawList:function() {
        var _this = this
        _this.projectUser = []
        _this.royalty.list = []
        _this.send({
          headers:'E/CaseLawList',
          data:{
            CaseId:_this.$route.query.caseId
          },
          success:function (res) {
            for(var index in res){
              for(var secIndex in res[index]){
                if(_this.isEmpty(res[index][secIndex])){
                  continue
                }
                _this.projectUser.push({
                  id:res[index][secIndex].UserId,
                  name:res[index][secIndex].UserName,
                  icon:res[index][secIndex].UserImg,
                })
                _this.royalty.list.push({
                  id:res[index][secIndex].UserId,
                  proportion:0,
                  amount:0,
                })
              }
            }
          }
        })
      },
      //获取到账状态列表
      getTrackingStateList:function(){
        var _this = this
        _this.trackingStateList = []
        _this.send({
          headers:'D/PayStatus',
          success:function (res) {
            for(var index in res){
              _this.trackingStateList.push({
                value:res[index].ProceedsResultsId,
                name:res[index].ProceedsResultsTitle,
              })
            }
            _this.getReceivablesList()
          }
        })
      },
      //删除流水
      deleteReceivables:function(id){
        var _this = this
        _this.send({
          headers:'G/DeleteGatheringById',
          confirm:true,
          data:{
            CaseId: _this.$route.query.caseId,
            ProceedsId:id,
          },
          success:function () {
            _this.getReceivablesList()
            // _this.getReceivablesAmount()
            _this.$Notice.success({
              title:'系统消息',
              desc:'删除成功！',
            })
          }
        })
      },
      //获取当事人列表
      getLitigationList:function(){
        var _this = this
        _this.send({
          headers:'E/LitigatsList',
          data:{
            CaseId:_this.$route.query.caseId,
          },
          success:function (res) {
            for(var index in res){
              if(res[index].LitigationStatusId==1){
                _this.client.push({
                  id:res[index].LitigantId,
                  name:res[index].LitigantName,
                  litigation:res[index].LawsuitId,
                  identity :res[index].LitigantTypeId,
                  IDCardCode:res[index].LitigantIdCard,
                })
              }
              if(res[index].LitigationStatusId==2){
                _this.opposed.push({
                  id:res[index].LitigantId,
                  name:res[index].LitigantName,
                  litigation:res[index].LawsuitId,
                  identity :res[index].LitigantTypeId,
                  IDCardCode:res[index].LitigantIdCard,
                })
              }
            }
          }
        })
      },
      //获取收款列表
      getReceivablesList:function () {
        var _this = this
        _this.list = []
        _this.send({
          headers:'G/ShowGathering',
          data:{
            ProceedsTypeId:_this.type,
            page : _this.search.page,
            pageSize : _this.search.pageSize,
            CaseId: _this.$route.query.caseId,
          },
          success:function (res) {
            _this.amount.sum = res.SumMoney
            _this.amount.notReceived = res.RemainPay
            _this.amount.received = res.YetPay
            _this.amount.royalty = res.Wage
            for(var index in res.List){
              _this.list.push({
                id:res.List[index].ProceedsId,
                createTime:res.List[index].ProceedsCreatedTime,
                affirmatoryTime:res.List[index].ProceedsEndTime,
                amount:res.List[index].ProceedsCount,
                state:res.List[index].ProceedsResultsId,
              })
            }
          }
        })
      }
    },
    computed:{
      phoneNumber:function () {
        return window.sessionStorage.phoneNumber
      },
      userToken:function () {
        return window.sessionStorage.userToken
      },
      groupId:function () {
        return window.sessionStorage.groupId
      },
      menuId:function () {
        return window.sessionStorage.menuId
      },
      userId:function () {
        return window.sessionStorage.userId
      },
    },
  }
</script>


